"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectView = selectView;
function selectView(state) {
  return state.view;
}